export default __webpack_public_path__ + "static/media/submit-24.77e0e4b5.webp";